export interface Palette {
  id: string;
  name: string;
  background: number;
  floor: number;
  floorAccent: number;
  player: number;
  playerAccent: number;
  enemy: number;
  enemyAccent: number;
  neutral: number;
  highlight: number;
  hit: number;
  block: number;
  heal: number;
  miss: number;
}

export const PALETTES: Palette[] = [
  {
    id: "ember",
    name: "Ember Court",
    background: 0x100d12,
    floor: 0x25202a,
    floorAccent: 0x413243,
    player: 0x3fa7d6,
    playerAccent: 0xb8f3ff,
    enemy: 0xdb4b56,
    enemyAccent: 0xffb36b,
    neutral: 0x846d4c,
    highlight: 0xffd166,
    hit: 0xff5f56,
    block: 0x8ee3ff,
    heal: 0x70e3a0,
    miss: 0xb3aeb8,
  },
  {
    id: "nocturne",
    name: "Arcane Nocturne",
    background: 0x070b16,
    floor: 0x111b2e,
    floorAccent: 0x24385b,
    player: 0x73e2a7,
    playerAccent: 0xd9ffe9,
    enemy: 0x9b7ede,
    enemyAccent: 0xf4c6ff,
    neutral: 0x60748b,
    highlight: 0xe5f77d,
    hit: 0xff7e79,
    block: 0x8ecae6,
    heal: 0x73e2a7,
    miss: 0xa8b6c8,
  },
  {
    id: "parchment",
    name: "Living Parchment",
    background: 0x18140e,
    floor: 0x3a3022,
    floorAccent: 0x665136,
    player: 0x5c9ead,
    playerAccent: 0xc7e6e8,
    enemy: 0xa65f46,
    enemyAccent: 0xf0c987,
    neutral: 0x8f7a52,
    highlight: 0xffe29a,
    hit: 0xe36b52,
    block: 0x9bc7c5,
    heal: 0x91c788,
    miss: 0xc2b69d,
  },
];

export interface RenderStyle {
  palette: Palette;
  pixelScale: number;
  lightingBands: number;
  motionExaggeration: number;
  windStrength: number;
  cameraPitch: number;
  cameraYaw: number;
  cameraZoom: number;
  cameraTarget: { x: number; y: number; z: number };
}
